"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducers = void 0;
var reducers = exports.reducers = {
  baseUrl: function baseUrl() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return state;
  },
  isSidenavReady: function isSidenavReady() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (action.type === 'setSidenavReady') {
      return true;
    }
    return state;
  }
};